var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/shop-msg-card-item.html');
/*require('./../../style/msg/tip-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');
var XssFilter = require('../../../lib/XssFilter');
var RichTextFormat = require('../../../lib/RichTextFormat');
var utils = require('./../../global/utils');
var isEmpty = utils.isEmpty;

var ShopMsgCardItem = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            shopItemContent: '<div class="im-msg-content-elements">{{elements}}</div>',
            title: '<div class="im-msg-content-element"><span class="im-element-topic" >{{ text }}</span></div>',
            action: '<div class="im-msg-content-element"><span class="im-element-action im-msg-action im-msg-click" data-index="{{index}}" data-msg-id="{{msg-id}}">{{ text }}</span></div>',
            href: '<div class="im-msg-content-element"><span class="im-element-action im-msg-action im-msg-click" href="{{href}}" data-index="{{index}}" data-msg-id="{{msg-id}}">{{ text }}</span></div>',
            buttonsContent: '<div class="im-msg-content-element"><div class="im-msg-buttons-container">{{buttons}}</div></div>',
            button: '<a class="im-msg-shop-button im-msg-action im-msg-click" data-index="{{index}}" data-msg-id="{{msg-id}}" href="{{href}}">{{ child.text }}<i class="im-msg-shop-button-icon"></i></a>',
            actions_map: {}
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);

    // 是否已经被render过
    this._rendered = false;
    this._isConfirmed = false;
};
ShopMsgCardItem.prototype = Object.create(BaseMsgItem.prototype);
ShopMsgCardItem.prototype.renderContent = function () {
    var msg = this._data.msg;
    var originalContent = msg.content;
    var defHref = 'javascript:void(0)';
    var elements_str = '';
    var self = this;
    if(!isEmpty(originalContent) && !isEmpty(originalContent.element)){
      var elements = originalContent.element;
      var index = 0;
      elements.forEach(function(element){
        switch(element.type){
          case 'text':
            var tpl = element.action ? self._options.action : self._options.title;
            if(element.action == 'openURL'){
              elements_str += self._options.href.replace('{{ text }}', element.text).replace('{{index}}', index).replace('{{msg-id}}', msg.msg_id).replace('{{href}}', element.actionData || defHref);
            }else{
              elements_str += (element.action ? self._options.action : self._options.title).replace('{{ text }}', element.text).replace('{{index}}', index).replace('{{msg-id}}', msg.msg_id);
            }

            if(element.action){
              self._options.actions_map[index] = element;
              index++;
            }
            break;
          case 'buttons':
            var buttons_str = '';
            var childs = element.childs;
            childs.forEach(function(child){
              if(child.type == 'button'){
                self._options.actions_map[index] = child;
                let _href = '';
                if (child.action === 'openURL') {
                  _href = child.actionData;
                }
                let _button_str = self._options.button.replace('{{ child.text }}', child.text).replace('{{index}}', index).replace('{{msg-id}}', msg.msg_id);
                buttons_str += (_href && _href.length ? _button_str.replace('{{href}}', _href) : _button_str.replace('href="{{href}}"', ''));
                index++;
              }
              buttons_str += '';
            });
            elements_str += self._options.buttonsContent.replace('{{buttons}}', buttons_str);
            break;
          default:
            break;
        }
      });
    }
    var _html = self._options.shopItemContent.replace('{{elements}}', elements_str);
    var msg_content = this._element.find('.im-msg-content');
    msg_content.html(_html);
    this._element.find('.im-msg-content').on('click', '[href]', function(e) {
      e.preventDefault();
      var url_jump = $(this).attr('href');
      if (url_jump && url_jump != defHref) {
        utils.openPage(url_jump);
      }
    });
};


module.exports = ShopMsgCardItem;
